import UAEPlate, { hasPlateDesign } from './UAEPlate';

const ALIASES = {
  abudhabi: 'abu_dhabi',
  'abu-dhabi': 'abu_dhabi',
  rak: 'ras_al_khaimah',
  rasalkhaimah: 'ras_al_khaimah',
  uaq: 'umm_al_quwain',
  umm_al_qaiwain: 'umm_al_quwain',
};
const CAT_ALIASES = { bike: 'motorcycle', commercial: 'private' };

export const normalizeEmirate = (e) => {
  const k = (e || 'dubai').toString().toLowerCase().trim().replace(/\s+/g, '_');
  return ALIASES[k] || k;
};

export const normalizeCategory = (c) => {
  const k = (c || 'private').toString().toLowerCase().trim();
  return CAT_ALIASES[k] || k;
};

/**
 * الشكل الرسمي الموحّد للوحات — يستخدم مكوّن UAEPlate الرسمي،
 * ومع الفئات بدون تصميم يعرض صورة الكود من الأدمن أو لوحة احتياطية بسيطة.
 */
export default function PlateVisual({ emirate, category = 'private', code = '', number = '', width = 220, imageUrl = '', className = '', showCodeOnPlate = true }) {
  const em = normalizeEmirate(emirate);
  const cat = normalizeCategory(category);
  const drawnCode = showCodeOnPlate === false ? '' : code;

  if (hasPlateDesign(em, cat)) {
    return (
      <div className={`inline-block ${className}`}>
        <UAEPlate emirate={em} category={cat} code={drawnCode} number={number} width={width} />
      </div>
    );
  }
  if (imageUrl) {
    return <img src={imageUrl} alt={`${code} ${number}`} style={{ width }} className={`rounded-lg ${className}`} />;
  }
  return (
    <div
      className={`inline-flex items-center justify-center gap-3 rounded-lg border-4 border-[#131313] bg-white shadow ${className}`}
      dir="ltr"
      style={{ width, height: Math.max(48, Math.round((width * 96) / 420)) }}
      data-testid="plate-fallback"
    >
      <span className="font-bold text-gray-900" style={{ fontSize: Math.max(14, width * 0.1) }}>{showCodeOnPlate === false ? '' : code}</span>
      <span className="font-black text-gray-900 tracking-wider" style={{ fontSize: Math.max(16, width * 0.11) }}>{number}</span>
    </div>
  );
}
